import * as localeUtils from "../node/locale";
import * as imageCompressor from "./imageCompressor";

export { localeUtils };
export { imageCompressor };
export { default as storageUtils } from "./storage/storage";
export { default as isMobile } from "./device/isMobile";
export { default as isWechat } from "./device/isWechat";
